module.exports = __webpack_public_path__ + "img/hot.be5030ca.webp";